import * as React from 'react';
import styled from 'styled-components';
import { Card } from './card/Card';
import { Icon } from './Icon';
import { ExpandedSingleChildColumn } from '../layout/Column';
import { MainGrid } from '../layout/MainGrid';

const NoMatch = (): React.ReactElement => (
  <MainGrid>
    <Card style={{ padding: '0px' }}>
      <ExpandedSingleChildColumn>
        <Container>
          <Icon name='error' style={{ fontSize: '5em' }} />
          <div style={{ maxWidth: '70%', textAlign: 'center' }}>
            <h1>Page Not Found</h1>
          </div>
        </Container>
      </ExpandedSingleChildColumn>
    </Card>
  </MainGrid>
);

export { NoMatch };

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
